/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type FreebiePopup_cart$ref = any;
export type RemoveProductFromCartInput = {|
  id: string
|};
export type RemoveProductFromCartCheckoutMutationVariables = {|
  input: RemoveProductFromCartInput,
  forklift?: ?boolean,
  street?: ?string,
  suburb?: ?string,
  city?: ?string,
  postcode?: ?string,
  useCredit?: ?boolean,
  useLoyaltyPoints?: ?boolean,
  shippingMethod?: ?string,
  ccType?: ?string,
  stripeToken?: ?string,
|};
export type RemoveProductFromCartCheckoutMutationResponse = {|
  +removeProductFromCart: ?{|
    +cart: ?{|
      +id: string,
      +storeCredits: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +name: ?string,
            +creditAmount: ?number,
          |}
        |}>
      |},
      +subtotal: ?number,
      +shippingCost: ?number,
      +grandTotal: ?number,
      +surcharges: ?$ReadOnlyArray<?{|
        +name: ?string,
        +amount: ?number,
      |}>,
      +loyaltyPoints: ?{|
        +accruing: ?number
      |},
      +discount: ?number,
      +discounts: ?$ReadOnlyArray<?{|
        +id: ?string,
        +name: ?string,
        +amount: ?number,
        +removable: ?boolean,
      |}>,
      +isOptFreebiesInCart: ?boolean,
      +lines: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +name: ?string,
            +unitPrice: ?number,
            +quantity: ?number,
            +unitDiscount: ?number,
            +unitSurcharge: ?number,
            +rowTotal: ?number,
            +priorityShipping: ?{|
              +getByDate: ?string
            |},
            +product: ?{|
              +id: string,
              +mainImage: ?{|
                +id: string,
                +thumbnail: ?string,
              |},
              +priorityShipping: ?{|
                +getByDate: ?string
              |},
            |},
          |}
        |}>
      |},
      +shippingMethods: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +code: ?string,
            +title: ?string,
            +price: ?number,
            +priceFormatted: ?string,
          |}
        |}>
      |},
      +paymentMethods: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +code: ?string,
            +title: ?string,
            +type: ?string,
          |}
        |}>
      |},
      +$fragmentRefs: FreebiePopup_cart$ref,
    |}
  |}
|};
export type RemoveProductFromCartCheckoutMutation = {|
  variables: RemoveProductFromCartCheckoutMutationVariables,
  response: RemoveProductFromCartCheckoutMutationResponse,
|};
*/


/*
mutation RemoveProductFromCartCheckoutMutation(
  $input: RemoveProductFromCartInput!
  $forklift: Boolean
  $street: String
  $suburb: String
  $city: String
  $postcode: String
  $useCredit: Boolean
  $useLoyaltyPoints: Boolean
  $shippingMethod: String
  $ccType: String
  $stripeToken: String
) {
  removeProductFromCart(input: $input) {
    cart {
      id
      storeCredits(first: 999) {
        edges {
          node {
            id
            name
            creditAmount
            __typename
          }
          cursor
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
      subtotal
      shippingCost(shippingMethod: $shippingMethod)
      grandTotal
      surcharges(ccType: $ccType, stripeToken: $stripeToken, forklift: $forklift) {
        name
        amount
        id
      }
      loyaltyPoints {
        accruing
      }
      discount
      discounts(useCredit: $useCredit, useLoyaltyPoints: $useLoyaltyPoints) {
        id
        name
        amount
        removable
      }
      isOptFreebiesInCart
      lines(first: 999) {
        edges {
          node {
            id
            name
            unitPrice
            quantity
            unitDiscount
            unitSurcharge
            rowTotal
            priorityShipping {
              getByDate
            }
            product {
              id
              mainImage {
                id
                thumbnail
              }
              priorityShipping {
                getByDate
              }
            }
            __typename
          }
          cursor
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
      shippingMethods(first: 20, street: $street, suburb: $suburb, city: $city, postcode: $postcode) {
        edges {
          node {
            code
            title
            price
            priceFormatted
            id
          }
        }
      }
      paymentMethods(first: 20) {
        edges {
          node {
            code
            title
            type
            id
          }
        }
      }
      ...FreebiePopup_cart
    }
  }
}

fragment FreebiePopup_cart on Cart {
  freebies(first: 99) {
    edges {
      node {
        id
        mode
        products(first: 99) {
          edges {
            node {
              id
              name
              urlSlug
              mainImage {
                id
                url
                thumbnail
              }
            }
          }
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ccType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "city"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "forklift"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "postcode"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shippingMethod"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "street"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "stripeToken"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "suburb"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "useCredit"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "useLoyaltyPoints"
},
v11 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v17 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreCreditEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StoreCredit",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          (v13/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "creditAmount",
            "storageKey": null
          },
          (v14/*: any*/)
        ],
        "storageKey": null
      },
      (v15/*: any*/)
    ],
    "storageKey": null
  },
  (v16/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subtotal",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "shippingMethod",
      "variableName": "shippingMethod"
    }
  ],
  "kind": "ScalarField",
  "name": "shippingCost",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "grandTotal",
  "storageKey": null
},
v21 = [
  {
    "kind": "Variable",
    "name": "ccType",
    "variableName": "ccType"
  },
  {
    "kind": "Variable",
    "name": "forklift",
    "variableName": "forklift"
  },
  {
    "kind": "Variable",
    "name": "stripeToken",
    "variableName": "stripeToken"
  }
],
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "LoyaltyPoints",
  "kind": "LinkedField",
  "name": "loyaltyPoints",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accruing",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "discount",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "useCredit",
      "variableName": "useCredit"
    },
    {
      "kind": "Variable",
      "name": "useLoyaltyPoints",
      "variableName": "useLoyaltyPoints"
    }
  ],
  "concreteType": "Discount",
  "kind": "LinkedField",
  "name": "discounts",
  "plural": true,
  "selections": [
    (v12/*: any*/),
    (v13/*: any*/),
    (v22/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "removable",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOptFreebiesInCart",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "PriorityShipping",
  "kind": "LinkedField",
  "name": "priorityShipping",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "getByDate",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnail",
  "storageKey": null
},
v29 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "QuoteLineEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "QuoteLine",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          (v13/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unitPrice",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "quantity",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unitDiscount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unitSurcharge",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rowTotal",
            "storageKey": null
          },
          (v27/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Product",
            "kind": "LinkedField",
            "name": "product",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductImage",
                "kind": "LinkedField",
                "name": "mainImage",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v28/*: any*/)
                ],
                "storageKey": null
              },
              (v27/*: any*/)
            ],
            "storageKey": null
          },
          (v14/*: any*/)
        ],
        "storageKey": null
      },
      (v15/*: any*/)
    ],
    "storageKey": null
  },
  (v16/*: any*/)
],
v30 = {
  "kind": "Literal",
  "name": "first",
  "value": 20
},
v31 = [
  {
    "kind": "Variable",
    "name": "city",
    "variableName": "city"
  },
  (v30/*: any*/),
  {
    "kind": "Variable",
    "name": "postcode",
    "variableName": "postcode"
  },
  {
    "kind": "Variable",
    "name": "street",
    "variableName": "street"
  },
  {
    "kind": "Variable",
    "name": "suburb",
    "variableName": "suburb"
  }
],
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priceFormatted",
  "storageKey": null
},
v36 = [
  (v30/*: any*/)
],
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v38 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 999
  }
],
v39 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 99
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RemoveProductFromCartCheckoutMutation",
    "selections": [
      {
        "alias": null,
        "args": (v11/*: any*/),
        "concreteType": "RemoveProductFromCartPayload",
        "kind": "LinkedField",
        "name": "removeProductFromCart",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Cart",
            "kind": "LinkedField",
            "name": "cart",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              {
                "alias": "storeCredits",
                "args": null,
                "concreteType": "StoreCreditConnection",
                "kind": "LinkedField",
                "name": "__CartView_storeCredits_connection",
                "plural": false,
                "selections": (v17/*: any*/),
                "storageKey": null
              },
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              {
                "alias": null,
                "args": (v21/*: any*/),
                "concreteType": "Surcharge",
                "kind": "LinkedField",
                "name": "surcharges",
                "plural": true,
                "selections": [
                  (v13/*: any*/),
                  (v22/*: any*/)
                ],
                "storageKey": null
              },
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              {
                "alias": "lines",
                "args": null,
                "concreteType": "QuoteLineConnection",
                "kind": "LinkedField",
                "name": "__CartView_lines_connection",
                "plural": false,
                "selections": (v29/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v31/*: any*/),
                "concreteType": "ShippingRateConnection",
                "kind": "LinkedField",
                "name": "shippingMethods",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ShippingRateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ShippingRate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v32/*: any*/),
                          (v33/*: any*/),
                          (v34/*: any*/),
                          (v35/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v36/*: any*/),
                "concreteType": "PaymentMethodConnection",
                "kind": "LinkedField",
                "name": "paymentMethods",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PaymentMethodEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PaymentMethod",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v32/*: any*/),
                          (v33/*: any*/),
                          (v37/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "paymentMethods(first:20)"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "FreebiePopup_cart"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v6/*: any*/),
      (v8/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Operation",
    "name": "RemoveProductFromCartCheckoutMutation",
    "selections": [
      {
        "alias": null,
        "args": (v11/*: any*/),
        "concreteType": "RemoveProductFromCartPayload",
        "kind": "LinkedField",
        "name": "removeProductFromCart",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Cart",
            "kind": "LinkedField",
            "name": "cart",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              {
                "alias": null,
                "args": (v38/*: any*/),
                "concreteType": "StoreCreditConnection",
                "kind": "LinkedField",
                "name": "storeCredits",
                "plural": false,
                "selections": (v17/*: any*/),
                "storageKey": "storeCredits(first:999)"
              },
              {
                "alias": null,
                "args": (v38/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "CartView_storeCredits",
                "kind": "LinkedHandle",
                "name": "storeCredits"
              },
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              {
                "alias": null,
                "args": (v21/*: any*/),
                "concreteType": "Surcharge",
                "kind": "LinkedField",
                "name": "surcharges",
                "plural": true,
                "selections": [
                  (v13/*: any*/),
                  (v22/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": null
              },
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              {
                "alias": null,
                "args": (v38/*: any*/),
                "concreteType": "QuoteLineConnection",
                "kind": "LinkedField",
                "name": "lines",
                "plural": false,
                "selections": (v29/*: any*/),
                "storageKey": "lines(first:999)"
              },
              {
                "alias": null,
                "args": (v38/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "CartView_lines",
                "kind": "LinkedHandle",
                "name": "lines"
              },
              {
                "alias": null,
                "args": (v31/*: any*/),
                "concreteType": "ShippingRateConnection",
                "kind": "LinkedField",
                "name": "shippingMethods",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ShippingRateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ShippingRate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v32/*: any*/),
                          (v33/*: any*/),
                          (v34/*: any*/),
                          (v35/*: any*/),
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v36/*: any*/),
                "concreteType": "PaymentMethodConnection",
                "kind": "LinkedField",
                "name": "paymentMethods",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PaymentMethodEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PaymentMethod",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v32/*: any*/),
                          (v33/*: any*/),
                          (v37/*: any*/),
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "paymentMethods(first:20)"
              },
              {
                "alias": null,
                "args": (v39/*: any*/),
                "concreteType": "FreebieTierConnection",
                "kind": "LinkedField",
                "name": "freebies",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FreebieTierEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FreebieTier",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mode",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v39/*: any*/),
                            "concreteType": "ProductConnection",
                            "kind": "LinkedField",
                            "name": "products",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProductEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Product",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v12/*: any*/),
                                      (v13/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "urlSlug",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ProductImage",
                                        "kind": "LinkedField",
                                        "name": "mainImage",
                                        "plural": false,
                                        "selections": [
                                          (v12/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "url",
                                            "storageKey": null
                                          },
                                          (v28/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "products(first:99)"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "freebies(first:99)"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0e4a77069539d0bcb32b624c7ce7d117",
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "removeProductFromCart",
            "cart",
            "storeCredits"
          ]
        },
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "removeProductFromCart",
            "cart",
            "lines"
          ]
        }
      ]
    },
    "name": "RemoveProductFromCartCheckoutMutation",
    "operationKind": "mutation",
    "text": "mutation RemoveProductFromCartCheckoutMutation(\n  $input: RemoveProductFromCartInput!\n  $forklift: Boolean\n  $street: String\n  $suburb: String\n  $city: String\n  $postcode: String\n  $useCredit: Boolean\n  $useLoyaltyPoints: Boolean\n  $shippingMethod: String\n  $ccType: String\n  $stripeToken: String\n) {\n  removeProductFromCart(input: $input) {\n    cart {\n      id\n      storeCredits(first: 999) {\n        edges {\n          node {\n            id\n            name\n            creditAmount\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n      subtotal\n      shippingCost(shippingMethod: $shippingMethod)\n      grandTotal\n      surcharges(ccType: $ccType, stripeToken: $stripeToken, forklift: $forklift) {\n        name\n        amount\n        id\n      }\n      loyaltyPoints {\n        accruing\n      }\n      discount\n      discounts(useCredit: $useCredit, useLoyaltyPoints: $useLoyaltyPoints) {\n        id\n        name\n        amount\n        removable\n      }\n      isOptFreebiesInCart\n      lines(first: 999) {\n        edges {\n          node {\n            id\n            name\n            unitPrice\n            quantity\n            unitDiscount\n            unitSurcharge\n            rowTotal\n            priorityShipping {\n              getByDate\n            }\n            product {\n              id\n              mainImage {\n                id\n                thumbnail\n              }\n              priorityShipping {\n                getByDate\n              }\n            }\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n      shippingMethods(first: 20, street: $street, suburb: $suburb, city: $city, postcode: $postcode) {\n        edges {\n          node {\n            code\n            title\n            price\n            priceFormatted\n            id\n          }\n        }\n      }\n      paymentMethods(first: 20) {\n        edges {\n          node {\n            code\n            title\n            type\n            id\n          }\n        }\n      }\n      ...FreebiePopup_cart\n    }\n  }\n}\n\nfragment FreebiePopup_cart on Cart {\n  freebies(first: 99) {\n    edges {\n      node {\n        id\n        mode\n        products(first: 99) {\n          edges {\n            node {\n              id\n              name\n              urlSlug\n              mainImage {\n                id\n                url\n                thumbnail\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7f6777cca89edd619544e53f1ce73fd6';

module.exports = node;
